module.exports = __webpack_public_path__ + "img/emsbanner3.5ea0aefc.png";